import React from 'react';
import EnumValueToText from 'components/base/EnumValueToText';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useGetHolidays } from 'hooks/product-price/base/getCEndHolidays';

interface IProps {
  enums: any;
  value: any;
}
const HolidayTips: React.FC<IProps> = (props) => {
  const { enums, value } = props || {};
  
  const { holidayEnum } = useGetHolidays(!!value);

  return (
    <>
      <EnumValueToText value={value} enums={enums} nameSpace='f_activity_holiday_limit_list' />
      {!!value && <Tooltip overlayInnerStyle={{ width: 265 }} title={
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {`节假日包含以下日期（订单的用车时间包含任意一天即认为命中节假日）：\n${
            holidayEnum.map(((item: any) => `${item.name}：${item.time_range?.join(' 至 ')}`)).join('\n')
          }`}
        </div>
      }>
        <QuestionCircleOutlined style={{ marginLeft: 12, color: 'rgba(0, 0, 0, 0.6)' }} />
      </Tooltip>}
    </>
  );
};

export default HolidayTips;